var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,3c0,0.6-0.4,1-1,1H5C4.4,4,4,4.4,4,5v3c0,0.6-0.4,1-1,1S2,8.6,2,8V5c0-1.7,1.3-3,3-3h3C8.6,2,9,2.4,9,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19c0,1.7,1.3,3,3,3h3c0.6,0,1-0.4,1-1s-0.4-1-1-1H5c-0.6,0-1-0.4-1-1v-3c0-0.6-0.4-1-1-1s-1,0.4-1,1V19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21,15c-0.6,0-1,0.4-1,1v3c0,0.6-0.4,1-1,1h-3c-0.6,0-1,0.4-1,1s0.4,1,1,1h3c1.7,0,3-1.3,3-3v-3C22,15.4,21.6,15,21,15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,2h-3c-0.6,0-1,0.4-1,1s0.4,1,1,1h3c0.6,0,1,0.4,1,1v3c0,0.6,0.4,1,1,1s1-0.4,1-1V5C22,3.3,20.7,2,19,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6,7.7c0-0.3,0.2-0.5,0.5-0.5h9.7c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5H7.1C6.8,8.2,6.6,8,6.6,7.7z M7.1,12.5h9.7 c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5H7.1c-0.3,0-0.5,0.2-0.5,0.5S6.8,12.5,7.1,12.5z M16.8,15.8h-4.8c-0.3,0-0.5,0.2-0.5,0.5 c0,0.3,0.2,0.5,0.5,0.5h4.8c0.3,0,0.5-0.2,0.5-0.5C17.3,16,17,15.8,16.8,15.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.420101e1f34686417903573996cbd9bf.svg";
export { ForwardRef as ReactComponent };